import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { Components, LocalStorageKeys, Modules, PreviousURL, QueryParamConstants } from '../constants/constants';
import { AuthSessionService } from './auth-session.service';
import { Location } from "@angular/common";
import { AdAccountStatus, MetaAdEffectiveStatusEnum, MetaAdStatusEnum } from '../constants/enum';
import type { GetPackageStatusResponse } from '../grpc-models/Common_pb';
import { GetXoopahPackageRequest, GetXoopahPackageResponse, XoopahPackageModel } from '../grpc-models/Subscription_pb';


interface FeatureUpdate {
  featureUpdateHtml: string;
  featureupdateId: number | null;
  onInbox: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  /**
   *
   */

  ///radius targetting
  private loaded = false;

  loadMapJsApi(apiKey: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.loaded) return resolve();

      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      if (existingScript) {
        this.loaded = true;
        return resolve();
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly&libraries=maps,marker,places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.loaded = true;
        resolve();
      };
      script.onerror = (err) => reject(err);

      document.head.appendChild(script);
    });
  }
  
  ///radius targetting.




  public userEmail!: any;
  isReferralUser: boolean = false;
  aiStaticCreativeGetStartedCount: number = 0;

  isOmsUser = false;

  subscriptionEndsOnDate: string = '';
  isCancellationReqested!: boolean;
  isSubscriptionCancelled!: boolean;
  isSubscriptionPaused: boolean = false;
  isAddonPurchased: boolean = false;
  planPrice!: number;
  monthlyPlanCredits!:number;

  /**
   * Whether subscriptionEndsOnDate (backend format "MMM dd, yyyy", e.g. "Sep 15,
   * 2026" — DateFormatExtensions.ToDateFormatForGrid()) has actually elapsed.
   * The topbar's "has been canceled" banner gates on this alongside
   * isSubscriptionCancelled, per an explicit dev instruction — isSubscriptionCancelled
   * alone was showing the "canceled" state before the plan had actually lapsed.
   */
  get hasSubscriptionEndDatePassed(): boolean {
    if (!this.subscriptionEndsOnDate) return false;
    const endDate = new Date(this.subscriptionEndsOnDate);
    return !isNaN(endDate.getTime()) && endDate.getTime() < Date.now();
  }
  isPackageExpired!: boolean;
  isFreemiumPackage!: boolean;
  isTrialPackage!: boolean;
  trialPackageDays!: number;
  extendedTrialDays!: number;
  remainingExtendedTrialDays!: number;
  isTrialExtended!: boolean;
  isExtendedTrialEnded!: boolean;
  billingId!: number;
  packageName!: string;
  isPaymentRefunded!: boolean;
  packageId!: number;
  businessName!: string;
  businessLogo!: string;
  timezoneOffset!: number;
  aiStaticCreativeLimit: number = 0;
  aiStaticcreativesCount!: number;
  aiStaticCreativeRevisionLimit: number = 0;
  totalAIStatiicCreatives!: number;
  generatedAIStaticCreatives!: number;
  packageStatusReady$ = new ReplaySubject<void>(1);
  businessSettingsReady$ = new ReplaySubject<void>(1);
  public sideNavToggle$ = new Subject<any>();
  toggleValue$ = this.sideNavToggle$.asObservable();
  isTestBusiness: boolean = true;
  isCouponFeatureEnabled = false;

  public closeSignalRHub$ = new Subject<any>();
  closeSignalRHubValue$ = this.closeSignalRHub$.asObservable();

  contactIdForCustomerPanelSubject$ = new Subject<number>();
  contactIdForCustomerPanel$ = this.contactIdForCustomerPanelSubject$.asObservable();

  paymentFilters: any = { isFiltersApplied: false };

  contactFilters: any = { isFiltersApplied: false };

  public sidebarPanelToggle$ = new Subject<any>();
  public saveGridView = new Subject<void>();
  sidebarPanelToggleValue$ = this.sidebarPanelToggle$.asObservable();

  public contactLabelSubject$ = new Subject<any>();
  contactLabel$ = this.contactLabelSubject$.asObservable();

  isArchiveNotificationEnabled: boolean | undefined = false;

  //isOnboardingBusinessHoursStepCompleted: boolean | undefined;

  public linkedContactSubject$ = new Subject<any>();
  linkedContact$ = this.linkedContactSubject$.asObservable();

  public closeDropDownMenu$ = new Subject<any>();
  closeDropDown$ = this.closeDropDownMenu$.asObservable();

  public closeMinimizeWindow$ = new Subject<any>();
  closeMinimize$ = this.closeMinimizeWindow$.asObservable();

  public openCalendlyPopup$ = new Subject<void>();
  openCalendlyPopupEvent$ = this.openCalendlyPopup$.asObservable();

  public gettingStartedSubject$ = new Subject<any>();
  gettingStarted$ = this.gettingStartedSubject$.asObservable();

  // Fires when a guest completes signup from the signup gate. The shell skips
  // loading a business name, logo and profile while the account is temporary,
  // so it needs telling once there is a real account to read.
  private guestSignedUpSubject$ = new Subject<void>();
  public guestSignedUp$ = this.guestSignedUpSubject$.asObservable();

  notifyGuestSignedUp(): void {
    this.guestSignedUpSubject$.next();
  }

  private resubscribePackageSubject$ = new Subject<any>();
  public resubscribePackage$ = this.resubscribePackageSubject$.asObservable();

  businessSubscription!: any;
  actionRestrictions: any = {
    isDisableAction: false,
    reasons: [],
  };

  public scheduleDaysSubject$ = new Subject<any>();
  scheduleDays$ = this.scheduleDaysSubject$.asObservable();

  public calendarMonthChangesSubject$ = new Subject<any>();
  calendarMonthChanges$ = this.calendarMonthChangesSubject$.asObservable();

  public isFormSelectedSubject$ = new Subject<any>();
  isFormSelected$ = this.isFormSelectedSubject$.asObservable();


  public sideNavOverlay$ = new Subject<any>();
  overlayValue$ = this.sideNavOverlay$.asObservable();


  private featureUpdate = new BehaviorSubject<FeatureUpdate>({
    featureUpdateHtml: '',
    featureupdateId: null,
    onInbox: false
  });

  featureUpdate$ = this.featureUpdate.asObservable();

  public disableFeatureUpdate$ = new Subject<any>();
  featureUpdateDisable$ = this.disableFeatureUpdate$.asObservable();

  public effectiveStatusClassMap: Map<MetaAdEffectiveStatusEnum | number, AdStatusInfo>

  ugcAvatarLimit: number = 0;
  ugcVoiceoverLimit: number = 0;
  monthlyAvatarLimit: number = 0;
  monthlyVoiceoverLimit: number = 0;
  planCredits: number = 0;
  addonCredits: number = 0;
  imageCreativeLimit: number = 0;
  monthlyImageCreativeLimit: number = 0;
  subscribedPackage!: XoopahPackageModel.AsObject;
  allPackages: XoopahPackageModel.AsObject[] = [];

  constructor(private router: Router,
   public location: Location,
   private authSessionService: AuthSessionService
 ) {

   this.effectiveStatusClassMap = new Map<MetaAdEffectiveStatusEnum | number, AdStatusInfo>(
     [
       [
         MetaAdEffectiveStatusEnum.ACTIVE,
         { 
           statusPillClass: 'active', 
           statusPillText: 'Active',
           message: 'Your ad is currently active and will run for {{x}} more days' 
         }
       ],
       [
         MetaAdEffectiveStatusEnum.PAUSED,
         {
           statusPillClass: 'paused',
           statusPillText: 'Paused',
           message: 'Your ad is paused and is not running at this time' ,
           tooltipPrimaryText: "The ad is stopped and not running. Reactivate to resume delivery."
         }
       ],
       [
         MetaAdEffectiveStatusEnum.PENDING_REVIEW,
         {
           statusPillClass: 'reviewing',
           statusPillText: 'Under Review',
           message: 'Your ad is under review and will start running once it is approved' ,
           tooltipPrimaryText: "Meta is reviewing your ad. This can take up to 72 hours."
         }
       ],
       [
         MetaAdEffectiveStatusEnum.CREDIT_CARD_NEEDED,
         {
           statusPillClass: 'credit-card-needed',
           statusPillText: 'Credit Card Needed',
           message: 'Please add a payment method to enable your ad to run' ,
         }
       ],
       [
         MetaAdEffectiveStatusEnum.PREAPPROVED,
         {
           statusPillClass: 'pre-approved',
           statusPillText: 'Pre-Approved',
           message: 'Your ad is pre-approved and will begin running shortly' ,
         }
       ],
       [
         MetaAdEffectiveStatusEnum.DISABLED,
         {
           statusPillClass: 'disabled',
           statusPillText: 'Disabled',
           message: 'Your ad has been disabled and cannot run at this time' ,
         }
       ],
       [
         MetaAdEffectiveStatusEnum.PENDING_PROCESS,
         {
           statusPillClass: 'pending-process',
           statusPillText: 'Pending Process',
           message: 'Your ad is currently being processed. Please check back soon' ,
           tooltipPrimaryText: undefined
         }
       ],
       [
         MetaAdEffectiveStatusEnum.WITH_ISSUES, 
         { 
           statusPillClass: 'error', 
           statusPillText: 'Error', 
           message: 'Your ad has issues that need attention before it can run', 
           tooltipPrimaryText: undefined 
         }
       ],
       [
         MetaAdEffectiveStatusEnum.COMPLETED,
         {
           statusPillClass: 'completed',
           statusPillText: 'Completed',
           message: 'Your ad has finished running' ,
           tooltipPrimaryText: "The ad has ended as its schedule has expired."
         }
       ],
       [
         MetaAdEffectiveStatusEnum.DISAPPROVED,
         {
           statusPillClass: 'disapproved',
           statusPillText: 'Rejected',
           message: 'Your ad was disapproved and cannot run. Please edit and resubmit it' ,
           tooltipPrimaryText: "The ad was disapproved due to policy violations.",
           tooltipLinkText: "Check reasons and fix issues.",
           tooltipLink: "https://www.facebook.com/business/help/1210227555661027"
         }
       ],
       [
         MetaAdEffectiveStatusEnum.PENDING_BILLING_INFO,
         {
           statusPillClass: 'update-billing-info',
           statusPillText: 'Fix Billing',
           message: 'Your ad is waiting for billing information to continue' ,
           tooltipPrimaryText: "The ad is paused due to billing issues.",
           tooltipLinkText: "Resolve to resume delivery.",
           tooltipLink: "https://business.facebook.com/billing_hub/payment_settings/"
         }
       ],
       [
         MetaAdEffectiveStatusEnum.CAMPAIGN_PAUSED, 
         {
           statusPillClass: 'paused',
           statusPillText: 'Paused',
           message: 'The campaign is paused, so this ad is not running at this time' 
         }
       ],
       [
         MetaAdEffectiveStatusEnum.ARCHIVED, 
         { 
           statusPillClass: 'archived',
            statusPillText: 'Archived',
             message: 'This ad is archived and is no longer active' 
           }
         ],
       [
         MetaAdEffectiveStatusEnum.ADSET_PAUSED, 
         { 
           statusPillClass: 'paused', 
           statusPillText: 'Paused', 
           message: 'The ad set is paused, so this ad is not running at this time' 
         }
       ],
       [
         MetaAdEffectiveStatusEnum.IN_PROCESS, 
         { 
           statusPillClass: 'in-process', 
           statusPillText: 'In Process', 
           message: 'Your ad is in process and will start running soon' 
         }
       ],

       //CUSTOM
       // [MetaAdEffectiveStatusEnum.UNKNOWN, { statusPillClass: 'unknown', statusPillText: 'Unknown' }],
       [
         MetaAdEffectiveStatusEnum.RUNNING,
         {
           statusPillClass: 'running',
           statusPillText: 'Running',
           message: 'Your ad is running and will continue for {{x}} more days' ,
           tooltipPrimaryText: "The ad is live and delivering impressions."
         }
       ],
       [
         MetaAdEffectiveStatusEnum.SCHEDULED,
         {
           statusPillClass: 'scheduled',
           statusPillText: 'Scheduled',
           message: 'Your ad is scheduled to run for {{x}} days' ,
           tooltipPrimaryText: "The ad will start running at the scheduled time."
         }
       ],
       [
         MetaAdEffectiveStatusEnum.DRAFT,
         {
           statusPillClass: 'draft',
           statusPillText: 'Draft',
           message: 'This is a draft ad. Please complete and publish it to start running' ,
           tooltipPrimaryText: "The Ad has not been published due to incomplete setup."
         }
       ],
     ]);
 }


  toggleMenu(data: any) {
    this.sideNavToggle$.next(data);
  }

  closeSignalRHub() {
    this.closeSignalRHub$.next(null);
  }

  toggleSidebarPanel(data: any) {
    this.sidebarPanelToggle$.next(data);
  }

  checkSignIn(url: string) {
    if (!this.checkIfTokenExits()) {
      this.router.navigate(['/login']);
      //this.signalRService.stop();
      this.closeSignalRHub();
      return false;
    } else {
      return true;
    }
  }
  checkToken() {
    if (!this.checkIfTokenExits()) {
      this.routeToLogin();
    }
  }
  checkIfTokenExits() {
    const token = this.authSessionService.getToken();
    if (token != null && token !== 'undefined')
      return true
    else
      return false;
  }

  routeToLogin() {

    let url = this.location.path();

    if (url) {
      url = url.toLowerCase();

      if (url.includes(Modules.Settings) && url.includes(Components.BillingListing)) {
        let queryParams =
        {
          [QueryParamConstants.XoopahRedirectUrlKey]: Components.BillingListing,
          [QueryParamConstants.AddCardKey]: ''
        };

        if (url.includes(QueryParamConstants.AddCardKey)) {
          queryParams =
          {
            [QueryParamConstants.XoopahRedirectUrlKey]: Components.BillingListing,
            [QueryParamConstants.AddCardKey]: QueryParamConstants.AddCardKey
          };
        }

        this.router.navigate(['/login'], { queryParams: queryParams });
      }
    }
    else {
      this.router.navigate(['/login']);
    }
  }



  updateContactLabel(newContactLabel: any, renderFor: any) {
    this.contactLabelSubject$.next({ newContactLabel, renderFor });
  }

  updateLinkedContact(linkedData: any) {
    this.linkedContactSubject$.next(linkedData);
  }

  updateGettingStarted(gettingStartedData: any) {
    this.gettingStartedSubject$.next(gettingStartedData);
  }

  CloseDropDown(data: any) {
    this.closeDropDownMenu$.next(data);
  }

  closeMinimizeWindowAction(data: any) {
    this.closeMinimizeWindow$.next(data);
  }

  resubscribePackage(objResubscribePackage: any) {
    this.resubscribePackageSubject$.next(objResubscribePackage);
  }

  setPackageStatus(data: GetPackageStatusResponse.AsObject) {
    this.isPackageExpired = data.ispackageexpired;
    this.isFreemiumPackage = data.isfreemiumpackage;
    this.isTrialPackage = data.istrialpackage;
    this.trialPackageDays = data.trialpackagedays;
    this.extendedTrialDays = data.extendedtrialdays;
    this.remainingExtendedTrialDays = data.remainingextendedtrialdays;
    this.packageName = data.packagename?.value + '';
    this.subscriptionEndsOnDate = data.subscriptionendsondate?.value + '';
    this.isCancellationReqested = data.iscancelationrequested;
    console.log('[GetPackageStatus] subscriptionEndsOnDate:', this.subscriptionEndsOnDate,
      '| isCancellationReqested:', this.isCancellationReqested,
      '| isSubscriptionCancelled:', data.issubscriptioncanceled,
      '| hasSubscriptionEndDatePassed:', this.hasSubscriptionEndDatePassed);
    this.isSubscriptionCancelled = data.issubscriptioncanceled;
    this.billingId = data.billingid;
    this.isPaymentRefunded = data.ispaymentrefunded;
    this.packageId = data.packageid;
    this.ugcAvatarLimit = data.ugcavatarlimit;
    this.ugcVoiceoverLimit = data.ugcvoiceoverlimit;
    this.monthlyAvatarLimit = data.monthlyavatarlimit;
    this.monthlyVoiceoverLimit = data.monthlyvoiceoverlimit,
    this.imageCreativeLimit = data.staticcreativelimit;
    this.monthlyImageCreativeLimit = data.monthlystaticcreativelimit;
    this.isTrialExtended = data.istrialextended;
    this.isExtendedTrialEnded = data.isextendedtrialended;
    this.aiStaticCreativeLimit = data.aistaticcreativelimit;
    this.aiStaticCreativeRevisionLimit = data.aistaticcreativerevisionlimit;
    this.aiStaticcreativesCount = data.totalaistaticcreatives;
    this.generatedAIStaticCreatives = data.generatedaistaticcreatives;
    this.planCredits = data.plancredits ?? 0;
    this.addonCredits = data.addoncredits ?? 0;
    this.isSubscriptionPaused = data.ispaused;
    this.isAddonPurchased = data.isaddonpurchased;
    // TEMP: checking what the wallet actually comes back as for a trial account.
    console.log('[GetPackageStatus] credits', {
      plancredits: data.plancredits,
      addoncredits: data.addoncredits,
      total: this.planCredits + this.addonCredits,
      packageId: data.packageid,
      packageName: data.packagename?.value,
      isTrialPackage: data.istrialpackage,
      isFreemiumPackage: data.isfreemiumpackage,
      isPaused: data.ispaused,
      isAddonPurchased: data.isaddonpurchased,
    });
    this.packageStatusReady$.next();
  }

  get totalCreditsAvailable(): number {
    return this.planCredits + this.addonCredits;
  }

  get hasCreditBalanceData(): boolean {
    return true;
  }

  get isOutOfGenerationCredits(): boolean {
    return this.hasCreditBalanceData && this.totalCreditsAvailable <= 0;
  }

  gotoBillingComponent(currentComponentUrl: string, settingComponentUrl: string) {

    if (!this.router.url.includes(PreviousURL.path)) {
      localStorage.setItem(LocalStorageKeys.PreviousURL, this.router.url);
    }

    let url = this.location.path();

    if (url) {
      url = url.toLowerCase();
      
      if (url.includes(Modules.Settings + '/' + Components.BillingListing) && !settingComponentUrl.toLowerCase().includes(QueryParamConstants.KeepSubscriptionKey.toLowerCase())
       && !this.isPaymentRefunded) {
        this.resubscribePackage({});
      }
      else {
        this.router.navigate([settingComponentUrl])
      }
    }


  }

  public updateScheduleDays(data: any) {
    this.scheduleDaysSubject$.next(data);
  }

  public triggerCalendarMonthChanges(data: any) {
    this.calendarMonthChangesSubject$.next(data);
  }


  public triggerisFormSelectedChanges(data: boolean) {
    this.isFormSelectedSubject$.next(data);
  }

  public bookingLink!: string;

  toggleMenuOverlay(data: any) {
    this.sideNavOverlay$.next(data);
  }

  // Convert date string to UTC timestamp
  public convertToUtc(dateString: string): Date {
    const date = new Date(dateString);
    return new Date(date.toUTCString());
  }

  public timeAgo(dateString: string): string {
    const utcDate = this.convertToUtc(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - utcDate.getTime()) / 1000);

    if (diffInSeconds < 60) {
      return `Just Now`;
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes}m ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      const minutes = Math.floor((diffInSeconds % 3600) / 60);
      if (minutes === 0) {
        return `${hours}h ago`;

      }
      return `${hours}h${minutes}m ago`;
    } else if (diffInSeconds < 2592000) {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days} days ago`;
    } else if (diffInSeconds < 31536000) {
      const months = Math.floor(diffInSeconds / 2592000);
      return `${months} months ago`;
    } else {
      const years = Math.floor(diffInSeconds / 31536000);
      return `${years} years ago`;
    }
  }

  public isMoreThanTwoHours(dateString: string): boolean {
    const utcDate = this.convertToUtc(dateString);
    const now = new Date(new Date().toUTCString());
    const diffInSeconds = Math.floor((now.getTime() - utcDate.getTime()) / 1000);
    const twoHoursInSeconds = 2 * 60 * 60;
    return diffInSeconds >= twoHoursInSeconds;
  }

  isMetaAdActive(statusNum: number | undefined, effectivestatus: number | undefined): boolean {

    if (!statusNum) {
      return false
    }

    const isStatusNumActive = statusNum == MetaAdStatusEnum.ACTIVE;
    // Check if status is nominally active but is overridden by parent paused status
    if (effectivestatus
      && (effectivestatus == MetaAdEffectiveStatusEnum.ADSET_PAUSED
        || effectivestatus == MetaAdEffectiveStatusEnum.CAMPAIGN_PAUSED
      )
      && (isStatusNumActive)
    ) {
      return false;
    }

    return isStatusNumActive;
  }

  getAdStatusInfo(
    isActive: boolean,
    adAccountStatus: number,
    isAdPublishedOnXoopah: boolean,
    startdate: string | undefined,
    enddate: string | undefined,
    effectiveStatusId: number | undefined
  ): AdStatusInfo {
    const now = new Date();
    const startTimestamp = startdate ? new Date(startdate) : null;
    const endTimestamp = enddate ? new Date(enddate) : null;
    
    let statusInfo: AdStatusInfo = new AdStatusInfo();

    if (isActive) {

      switch (effectiveStatusId) {
        case MetaAdEffectiveStatusEnum.ACTIVE:
          if (startTimestamp && startTimestamp > now) {
            statusInfo = this.effectiveStatusClassMap.get(MetaAdEffectiveStatusEnum.SCHEDULED) ?? statusInfo;
          } else if (endTimestamp && endTimestamp < now) {
            statusInfo = this.effectiveStatusClassMap.get(MetaAdEffectiveStatusEnum.COMPLETED) ?? statusInfo;
          } else if (adAccountStatus == AdAccountStatus.ACTIVE || adAccountStatus == AdAccountStatus.PENDING_SETTLEMENT || adAccountStatus == AdAccountStatus.IN_GRACE_PERIOD) {
            statusInfo = this.effectiveStatusClassMap.get(MetaAdEffectiveStatusEnum.RUNNING) ?? statusInfo;
          } else {
            statusInfo = effectiveStatusId ? this.effectiveStatusClassMap.get(effectiveStatusId) ?? statusInfo : statusInfo;
          }
          break;
        default:
          statusInfo = effectiveStatusId ? this.effectiveStatusClassMap.get(effectiveStatusId) ?? statusInfo : statusInfo;
          break;
      }

    } else {

      if (!isAdPublishedOnXoopah) {
        statusInfo = this.effectiveStatusClassMap.get(MetaAdEffectiveStatusEnum.DRAFT) ?? statusInfo;
      }
      else if (endTimestamp && endTimestamp < now && !enddate?.startsWith('0001-01-01')) {
        statusInfo = this.effectiveStatusClassMap.get(MetaAdEffectiveStatusEnum.COMPLETED) ?? statusInfo;
      }
      else {
        statusInfo = effectiveStatusId ? this.effectiveStatusClassMap.get(effectiveStatusId) ?? statusInfo : statusInfo;
      }

    }

    return statusInfo;
  }

  setFeatureUpdate(html: string, id: number, onInbox: boolean) {
    this.featureUpdate.next({ featureUpdateHtml: html, featureupdateId: id, onInbox: onInbox });
  }

  setFeatureUpdateDisable(data: any) {
    this.disableFeatureUpdate$.next(data);
  }

  onKeyDown(event: KeyboardEvent){}
}

export class AdStatusInfo {
  statusPillText: string = 'Unknown';
  statusPillClass: string = 'unknown';
  message: string = '';
  tooltipPrimaryText?: string;
  tooltipLinkText?: string;
  tooltipLink?: string;
}

